import { format } from 'date-fns';

import Card from '@/components/Card';
import Modal from '@/components/Modal';
import Stack from '@/components/Stack';
import TextStack from '@/components/TextStack';
import { Body, Small } from '@/components/Typography';
import { SmsLog } from '@/services/smsLogsAPI';

type Props = {
  log: SmsLog;
  onClose: () => void;
};

const Field = ({ label, value }: { label: string; value: string }) => (
  <TextStack spacing="tight">
    <Small color="light" weight="medium">
      {label}
    </Small>
    <Body>{value}</Body>
  </TextStack>
);

// Read-only view of a single logged SMS: the exact body that was sent plus
// its delivery metadata. Opened from the SMS Logs list for debugging.
const SmsLogDetailModal = ({ log, onClose }: Props) => (
  <Modal size="sm" title="SMS Message" onRequestClose={onClose}>
    <Card.Section>
      <Stack vertical gap={16}>
        <Field label="To" value={log.to_phone} />
        <Field label="Type" value={log.sms_type || '—'} />
        <Field label="Status" value={log.status} />
        <Field
          label="Sent At"
          value={format(new Date(log.created_at), 'MMM d, yyyy h:mm:ss a')}
        />
        {log.twilio_sid && <Field label="Twilio SID" value={log.twilio_sid} />}
        {log.worker_id != null && (
          <Field label="Worker ID" value={String(log.worker_id)} />
        )}
        {log.error_message && <Field label="Error" value={log.error_message} />}
        <TextStack spacing="tight">
          <Small color="light" weight="medium">
            Message
          </Small>
          <div
            style={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              fontSize: 14,
              lineHeight: 1.5,
            }}
          >
            {log.body}
          </div>
        </TextStack>
      </Stack>
    </Card.Section>
  </Modal>
);

export default SmsLogDetailModal;
